import { LEFT_CENTRAL_BLOCK_WIDTH } from '@components/ncFileVersions/constants';

// Horizontal inset around the version list inside the picker popup.
export const PICKER_HORIZONTAL_PADDING = 15;

// Popup width: LeftColumn's natural width plus the horizontal inset on both sides.
export const PICKER_WIDTH = LEFT_CENTRAL_BLOCK_WIDTH + PICKER_HORIZONTAL_PADDING * 2;

// Vertical space (header + footer) subtracted from the popup's available height to cap the list; over-reserved on purpose so the buttons never clip.
export const PICKER_HEADER_FOOTER_RESERVE = 200;

// Floor so the list stays usable on very short viewports.
export const PICKER_MIN_LIST_HEIGHT = 160;

// Fallback list cap used only when the popup does not inject maxHeight (e.g. direct mount in tests).
export const PICKER_FALLBACK_MAX_HEIGHT = 600;
